import React, { useRef, useEffect } from "react";
import { GRAINS, COLORS, PRODUCT } from "constants/appConstant";
import { useHeadWallStore } from "store";
import { CloseIcon } from "assets/images";

function HeadwallColor({ setShowModal, index }) {
  const { values, setValues } = useHeadWallStore();
  let { headwalls, chase_color, chase_background,model } = values;
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal({ open: false, index: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowModal]);

  const handleChange = (key, val) => {
    const rails = [...headwalls];
    if (index !== undefined) {
      if (key === "color") {
        rails[index]["color"] = val;
        rails[index]["background"] = "";
      } else if (key === "background") {
        rails[index]["color"] = "";
        rails[index]["background"] = val;
      }
    } else {
      if (key === "color") {
        chase_color = val;
        chase_background = "";
      } else if (key === "background") {
        chase_color = "";
        chase_background = val;
      }
    }
    setValues({ ...values, headwalls: rails, chase_color, chase_background });
  };

  const filteredColors =
  model !== PRODUCT.SECURITY ? COLORS.slice(0, -1) : COLORS;
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-end p-4 text-center sm:items-center sm:p-0 mr-16">
          <div
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:max-w-[18rem]"
            ref={modalRef}
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className=" pt-4 ">
                <div className="flex w-100 justify-between">
                  <p className="font-bold text-base txtBlue headingTxt">
                    Headwall Grains/Colors
                  </p>
                  <img
                    src={CloseIcon}
                    alt=""
                    className="cursor-pointer closeBtnModal"
                    onClick={() => setShowModal({ open: false, index: null })}
                  />
                </div>
                {model!==PRODUCT.SECURITY&&(
                <div className="grid gap-2 grid-cols-4 my-2 bg-white rounded-md border-2 p-[7px]">
                  {Object.keys(GRAINS).map((key, i) => (
                    <img
                      key={i}
                      className={`rounded border-2 h-[44px] w-full cursor-pointer flex justify-center items-center ${
                        key === headwalls[index]?.background
                          ? "border-sky-600"
                          : "border-slate-300"
                      }`}
                      style={{ objectFit: "cover" }}
                      onClick={() => handleChange("background", key)}
                      src={GRAINS[key]}
                      alt="...img"
                    />
                  ))}
                </div>
                )}
              </div>
              <div className="grid gap-2 grid-cols-4 my-2 bg-white rounded-md border-2 p-[7px]">
                {filteredColors.map((col, i) => (
                  <div
                    className={`rounded border-2  h-[44px] w-full cursor-pointer flex justify-center items-center  ${
                      headwalls[index]?.color === col
                        ? "border-sky-600"
                        : "border-slate-300"
                    }`}
                    key={i}
                    style={{ background: col }}
                    onClick={() => handleChange("color", col)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeadwallColor;
